// This seems like it's not in line with context, i.e. what about secrets and users
export const determineContext = pathname => {
  if (pathname.includes('chest')) return 'Chests';
  if (pathname.includes('team')) return 'Teams';
  if (pathname.includes('setting')) return 'Settings';
  return 'Chests';
};

export const filterAllButAdmins = userList => userList.filter(user => user['administrator']);
